import React from "react";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../../lib/site";

export const Testimonials = () => {
  return (
    <section id="reviews" data-testid="reviews-section" className="py-20 md:py-28 bg-[#F6F5F0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="font-heading font-bold uppercase tracking-[0.2em] text-[#C8102E] text-sm">
          Reviews
        </p>
        <h2 className="mt-2 font-heading text-4xl sm:text-5xl font-extrabold uppercase tracking-tight text-[#0E2A56]">
          What Neighbors Are Saying
        </h2>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="relative bg-white border-2 border-[#0E2A56] p-8"
            >
              <Quote className="absolute top-6 right-6 h-10 w-10 text-[#0E2A56]/10" strokeWidth={2} />
              <div className="flex text-[#F6B100] mb-4">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="h-5 w-5 fill-current" />
                ))}
              </div>
              <p className="text-slate-800 text-lg leading-relaxed font-medium">"{t.text}"</p>
              <div className="mt-6 pt-4 border-t-2 border-[#F6F5F0]">
                <p className="font-heading font-bold uppercase tracking-wide text-[#0E2A56]">
                  {t.name}
                </p>
                <p className="text-sm text-[#C8102E] font-semibold">{t.location}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
